import { render, staticRenderFns } from "./GoodsCategory.vue?vue&type=template&id=674a6bb8&scoped=true"
import script from "./GoodsCategory.vue?vue&type=script&lang=js"
export * from "./GoodsCategory.vue?vue&type=script&lang=js"
import style0 from "./GoodsCategory.vue?vue&type=style&index=0&id=674a6bb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a6bb8",
  null
  
)

export default component.exports